import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated as of 2021-02-23, only file-upload used it */
@Pipe({
	name: 'any',
	pure: true,
})
export class AnyPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		return value;
	}
}
